/*
 * @Author: weiyanna weiyanna@jd.com
 * @Date: 2026-02-02 15:39:43
 * @LastEditors: weiyanna weiyanna@jd.com
 * @LastEditTime: 2026-03-24 18:38:03
 * @FilePath: /isp_International/src/dataPort/reportId.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
// 埋点命名建议：页面 + 功能 + 事件
// 点击埋点
// 这里的作用看起来只有记录的作用，内容都是透传的，所以我们勇敢果断的拒绝了这种方式，
// 直接在代码中写死eventId，如果想要统计当前所有埋点，也简单，用node脚本取出页面上所有data-track的值。
export const pageIds = {
  ProductList: 'ProductList', // 首页-搜索按钮-点击----埋点
};

export const clickId = {
  home_searchButton_click: 'home_searchButton_click', // 首页-搜索按钮-点击----埋点
  search_button: 'search_button', // 垂搜搜索按钮点击
  search_guide: 'search_guide', // 搜索引导点击
  search_add_cart: 'search_add_cart', // 搜索结果页-加入购物车-点击埋点
  search_product_info: 'search_product_info', // 搜索结果页-商品信息-点击埋点
};
// 曝光埋点
export const expId = {
  home_helpAndFeedback_exposure: 'home_helpAndFeedback_exposure', //首页-帮助与反馈-曝光--埋点
  searchList_GoodsList_exposure: 'searchList_GoodsList_exposure', //搜索列表-商品列表-曝光--埋点
  skuDetail_exposure: 'skuDetail_exposure', //商品详情-曝光--埋点
  searchlist_cable_skuexposure: 'search_cable_skuexposure', // 搜列商品曝光
  searchlist_result_counts: 'searchlist-result_counts', // 搜索结果页曝光商品数，用于获取搜索无结果和少无结果数据
};
// 业务线标识
// export const businessId = {
//   lxId: 'lx', //业务ID
// };

// 业务线标识
export const businessId  = {
  pageId: 'wisp', //页面ID
}
